(() => {
if (window.__rebRecoveryInitialized) return;
window.__rebRecoveryInitialized = true;

document.addEventListener('click', function (event) {
  const purchase = event.target.closest('[data-reb-purchase]');
  if (purchase) {
    const quantity = purchase.querySelector('input[name="quantity"]');
    if (event.target.closest('[data-quantity-minus]')) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    if (event.target.closest('[data-quantity-plus]')) quantity.value = Number(quantity.value || 1) + 1;
    const choice = event.target.closest('[data-variant-id]');
    if (choice) {
      purchase.querySelectorAll('[data-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
      const variantInput = purchase.querySelector('.product-variant-id');
      variantInput.value = choice.dataset.variantId;
      variantInput.disabled = choice.dataset.available !== 'true';
      purchase.querySelector('.product-form__submit').disabled = variantInput.disabled;
      purchase.querySelector('[data-reb-price]').textContent = choice.dataset.price;
      const rating = Number(choice.dataset.rating);
      const reviewCount = choice.dataset.reviewCount;
      if (Number.isFinite(rating)) {
        purchase.querySelector('[data-reb-rating]').textContent = `★ ${rating.toFixed(1)} rated${reviewCount ? ` from ${reviewCount} reviews` : ''}`;
      }
      const image = purchase.closest('.reb-feature').querySelector('[data-reb-product-image]');
      image.src = choice.dataset.imageUrl;
      image.alt = choice.dataset.imageAlt;
    }
  }
});

function observeRecoveryFooter() {
  const footer = document.querySelector('.reb-light-footer');
  if (!footer) return;
  document.querySelectorAll('.reb-mobile-shop, [data-reb-pdp-sticky]').forEach(stickyBar => {
    if (stickyBar.dataset.footerObserved === 'true') return;
    stickyBar.dataset.footerObserved = 'true';
    const observer = new IntersectionObserver(entries => {
      stickyBar.classList.toggle('is-hidden-for-footer', entries[0].isIntersecting);
    });
    observer.observe(footer);
  });
}

function initRecoveryPdp() {
  document.querySelectorAll('[data-reb-pdp]').forEach(pdp => {
    if (pdp.dataset.initialized === 'true') return;
    pdp.dataset.initialized = 'true';
    const gallery = pdp.querySelector('[data-reb-gallery-viewport]');
    const slides = [...pdp.querySelectorAll('[data-reb-media-index]')];
    const targets = [...pdp.querySelectorAll('[data-reb-media-target]')];
    const counter = pdp.querySelector('[data-reb-gallery-counter]');
    const previous = pdp.querySelector('[data-reb-gallery-prev]');
    const next = pdp.querySelector('[data-reb-gallery-next]');
    let currentIndex = 0;
    function setCurrent(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      targets.forEach(target => target.setAttribute('aria-current', String(Number(target.dataset.rebMediaTarget) === currentIndex)));
      if (counter) counter.textContent = `${currentIndex + 1} / ${slides.length}`;
      if (previous) { previous.disabled = currentIndex === 0; previous.setAttribute('aria-disabled', String(previous.disabled)); }
      if (next) { next.disabled = currentIndex === slides.length - 1; next.setAttribute('aria-disabled', String(next.disabled)); }
    }
    function goTo(index) {
      if (!gallery || !slides[index]) return;
      gallery.scrollTo({ left: index * gallery.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      setCurrent(index);
    }
    targets.forEach(target => target.addEventListener('click', () => goTo(Number(target.dataset.rebMediaTarget))));
    previous?.addEventListener('click', () => goTo(currentIndex - 1));
    next?.addEventListener('click', () => goTo(currentIndex + 1));
    if (gallery && slides.length > 1) {
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => setCurrent(Math.round(gallery.scrollLeft / gallery.clientWidth)));
      }, { passive: true });
    }

    const form = pdp.querySelector('.reb-pdp-form');
    const quantity = form?.querySelector('input[name="quantity"]');
    const total = pdp.querySelector('[data-reb-pdp-total]');
    const mobilePrice = pdp.querySelector('.reb-pdp-submit__mobile-price');
    const unitPrice = Number(pdp.dataset.priceCents);
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: pdp.dataset.currency || 'USD' });
    function updateQuantity(normalize = false) {
      const value = Math.max(1, Math.floor(Number(quantity.value) || 1));
      if (normalize) quantity.value = value;
      const formatted = formatter.format(unitPrice * value / 100);
      total.textContent = formatted;
      total.hidden = value === 1;
      mobilePrice.textContent = formatted;
    }
    pdp.querySelector('[data-reb-pdp-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); updateQuantity(true); });
    pdp.querySelector('[data-reb-pdp-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; updateQuantity(true); });
    quantity?.addEventListener('change', () => updateQuantity(true));
    quantity?.addEventListener('input', () => updateQuantity());
    form?.addEventListener('submit', () => updateQuantity(true));

    const buyBox = pdp.querySelector('[data-reb-buy-box]');
    const buyDetails = pdp.querySelector('.reb-pdp-buy__details');
    const sticky = pdp.querySelector('[data-reb-pdp-sticky]');
    if (buyBox && sticky) {
      function updateSticky() {
        const observedBox = window.matchMedia('(max-width: 767px)').matches ? buyDetails : buyBox;
        sticky.classList.toggle('is-visible', observedBox.getBoundingClientRect().bottom < 0);
      }
      const observer = new IntersectionObserver(updateSticky);
      observer.observe(buyDetails);
      let stickyUpdateTimer;
      function scheduleStickyUpdate() {
        clearTimeout(stickyUpdateTimer);
        stickyUpdateTimer = setTimeout(updateSticky, 100);
      }
      window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
      window.addEventListener('resize', scheduleStickyUpdate);
      window.addEventListener('orientationchange', scheduleStickyUpdate);
      updateSticky();
      sticky.querySelector('[data-reb-pdp-add]')?.addEventListener('click', () => form?.requestSubmit(form.querySelector('button[name="add"]')));
    }
  });
}

function initRecoveryPage() {
  initRecoveryPdp();
  observeRecoveryFooter();
  initRecoveryCollection();
  initSocialVideos();
}

function initSocialVideos() {
  document.querySelectorAll('.reb-social__card--video video[data-reb-video-src]').forEach(video => {
    if (video.dataset.rebObserved === 'true') return;
    video.dataset.rebObserved = 'true';
    const observer = new IntersectionObserver(entries => {
      const near = entries[0].isIntersecting;
      if (near) {
        if (!video.src) video.src = video.dataset.rebVideoSrc;
        video.play().catch(() => {});
      } else {
        video.pause();
        video.classList.remove('is-playing');
      }
    }, { rootMargin: '100% 100%', threshold: 0 });
    video.addEventListener('playing', () => video.classList.add('is-playing'));
    observer.observe(video);
  });
}

function initRecoveryCollection() {
  const grid = document.querySelector('.reb-col-grid');
  if (!grid) return;
  const preview = new URLSearchParams(window.location.search).get('view') === 'recovery-era';
  document.querySelectorAll('.reb-col-header__pill, [data-reb-col-more]').forEach(link => {
    if (!preview) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('view', 'recovery-era');
    link.href = url.pathname + url.search + url.hash;
  });
  // The reused review section has a product-only anchor on recovery templates.
  const reviewsLink = document.querySelector('.reb-reviews__all');
  if (reviewsLink) reviewsLink.href = '/products/the-riley#reviews';
  const drewShopLink = document.querySelector('.reb-reviews__drew .reb-btn');
  if (drewShopLink) drewShopLink.href = '/products/the-riley';
  if (grid.dataset.rebColInitialized === 'true') return;
  grid.dataset.rebColInitialized = 'true';
  grid.addEventListener('click', async event => {
    const more = event.target.closest('[data-reb-col-more]');
    if (!more || more.dataset.loading === 'true') return;
    event.preventDefault();
    more.dataset.loading = 'true';
    more.setAttribute('aria-disabled', 'true');
    try {
      const response = await fetch(more.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection page could not load');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = page.querySelector('.reb-col-grid__items');
      if (!nextGrid) throw new Error('Collection grid was missing');
      [...nextGrid.children].forEach(card => card.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; }));
      grid.querySelector('[data-reb-col-items]').append(...nextGrid.children);
      const nextLink = page.querySelector('[data-reb-col-more]');
      if (nextLink) {
        const url = new URL(nextLink.href, window.location.origin);
        if (preview) url.searchParams.set('view', 'recovery-era');
        more.href = url.pathname + url.search + url.hash;
      } else {
        more.remove();
      }
      initRecoveryCollection();
    } catch (error) {
      window.location.assign(more.href);
    } finally {
      more.dataset.loading = 'false';
      more.removeAttribute('aria-disabled');
    }
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRecoveryPage);
else initRecoveryPage();
document.addEventListener('shopify:section:load', initRecoveryPage);

document.addEventListener('touchstart', function (event) {
  event.target.closest('.reb-social__viewport')?.classList.add('is-touching');
}, { passive: true });
document.addEventListener('touchend', function (event) {
  event.target.closest('.reb-social__viewport')?.classList.remove('is-touching');
}, { passive: true });
document.addEventListener('touchcancel', function (event) {
  event.target.closest('.reb-social__viewport')?.classList.remove('is-touching');
}, { passive: true });
})();
